import styled, { css } from "styled-components";

export const MenuHighlight = styled.div`
  margin-top: ${({ theme }) => theme.rem(32)};
  position: relative;
  background-color: lightgreen;
  padding: ${({ theme }) => theme.rem(24)};
  border-radius: ${({ theme }) => theme.rem(16)};
  
  
  ${({ theme }) => theme.mediaQuery.lg(`
    margin-top: ${theme.rem(80)};
  `)}

  ${({ theme }) => theme.mediaQuery.xl(`
    margin-top: ${theme.rem(0)};
  `)}
`